import { useEffect } from 'react'
import '@/style/industry.scss'
import PageHero from '@/components/PageHero'
import Reveal from '@/components/Reveal'
import heroImg from '@/images/site/hero-industry.jpg'
import windImg from '@/images/site/domain-wind.jpg'
import solarImg from '@/images/site/domain-solar.jpg'

const DOMAINS = [
  {
    icon: require('@/images/industry/domain1.png'),
    title: '新能源',
    content:
      '在我国“碳达峰、碳中和”政策推动下，新能源发电和新能源汽车等行业迎来了空前的高速发展期。新能源行业对绝缘材料产品的耐候性（耐高热、耐冲击、耐腐蚀、耐辐照等）需求应用要高于传统行业，丰源电力研发创新多种新产品，被应用于风电、光伏、及储能等行业。',
  },
  {
    icon: windImg,
    title: '风电',
    content:
      '风力发电设备所处的工作环境存在复杂多变性，设备长期处于高温、高湿、高盐雾、风雨侵蚀、冲击、振动等的环境中。因此对风力发电设备应用的绝缘材料提出了更高性能和使用寿命的使用要求。丰源电力产品以稳定的性能来保证风力发电设备长期顺利的运转。',
  },
  {
    icon: solarImg,
    title: '光伏',
    content:
      '光伏发电即利用相关媒介将最清洁、安全和可靠的太阳能转换为电能的一种技术。光伏行业作为推动能源转型和绿色经济复苏的“主力产业”，正迎来前所未有的发展机遇。为进一步促进相关技术提升，丰源电力协助开发高性能光伏发电的应用新材料，进一步促进“碳达峰、碳中和”的目标达成。',
  },
]

const PRODUCT_GROUPS = [
  {
    title: '加工件',
    en: 'Machined Parts',
    desc: '板料深加工，按图纸尺寸与公差交付。',
    items: [
      { icon: require('@/images/industry/SMC加工件.jpg'), content: 'SMC加工件' },
      { icon: require('@/images/industry/PC板加工件.jpg'), content: 'PC板加工件' },
      { icon: require('@/images/industry/尼龙板加工件.jpg'), content: '尼龙板加工件' },
      { icon: require('@/images/industry/树脂板加工件.jpg'), content: '树脂板加工件' },
    ],
  },
  {
    title: 'SMC 模压件',
    en: 'Molded Components',
    desc: '模压一次成型，尺寸稳定、表面光洁。',
    items: [
      { icon: require('@/images/industry/SMC模压件 (1).jpg'), content: 'SMC模压件 (1)' },
      { icon: require('@/images/industry/SMC模压件 (2).jpg'), content: 'SMC模压件 (2)' },
      { icon: require('@/images/industry/SMC模压件 (3).jpg'), content: 'SMC模压件 (3)' },
      { icon: require('@/images/industry/SMC模压件 (4).jpg'), content: 'SMC模压件 (4)' },
    ],
  },
  {
    title: '型材',
    en: 'Profiles',
    desc: '槽型、工字型与王字梁等工程型材。',
    items: [
      { icon: require('@/images/industry/槽型材加工件.jpg'), content: '槽型材加工件' },
      { icon: require('@/images/industry/型材加工件.jpg'), content: '型材加工件' },
      { icon: require('@/images/industry/“工”字型型材.jpg'), content: '“工”字型型材' },
      { icon: require('@/images/industry/“王”字梁型材 (1).jpg'), content: '“王”字梁型材' },
    ],
  },
  {
    title: '模塑件',
    en: 'Injection Parts',
    desc: '注塑成型，适用于复杂结构件。',
    items: [
      { icon: require('@/images/industry/模塑件 (1).jpg'), content: '模塑件 (1)' },
      { icon: require('@/images/industry/模塑件 (2).jpg'), content: '模塑件 (2)' },
    ],
  },
]

function Industry() {
  useEffect(() => {
    const type = new URLSearchParams(window.location.search).get('type')
    if (!type) return
    const el = document.getElementById(type)
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, [])

  return (
    <>
      <PageHero
        eyebrow="Products"
        title="产品与应用领域"
        image={heroImg}
        stat={[{ value: '4', label: '产品品类' }]}
      />

      {/* ---------- 应用领域 ---------- */}
      <section className="section industry__domains" id="applicationDomain">
        <div className="mainContent">
          <Reveal className="secHead">
            <p className="secHead__eyebrow">Application</p>
            <h2 className="secHead__title">应用领域</h2>
          </Reveal>

          <div className="industry__domainList">
            {DOMAINS.map((item, i) => (
              <Reveal
                className="domainRow"
                key={item.title}
                delay={i * 110}
              >
                <div className="domainRow__media">
                  <img src={item.icon} alt={item.title} loading="lazy" />
                </div>
                <div className="domainRow__text">
                  <span className="domainRow__num">0{i + 1}</span>
                  <h3 className="domainRow__title">{item.title}</h3>
                  <p className="domainRow__desc">{item.content}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ---------- 产品展示 ---------- */}
      <section className="section section--soft industry__products" id="industryShow">
        <div className="mainContent">
          <Reveal className="secHead">
            <p className="secHead__eyebrow">Gallery</p>
            <h2 className="secHead__title">产品展示</h2>
          </Reveal>

          <div className="industry__groups">
            {PRODUCT_GROUPS.map((group, gi) => (
              <div className="productGroup" key={group.title}>
                <Reveal className="productGroup__head" delay={gi * 60}>
                  <h3>{group.title}</h3>
                  <span className="productGroup__en">{group.en}</span>
                  <p>{group.desc}</p>
                </Reveal>

                <div className="productGroup__grid">
                  {group.items.map((item, i) => (
                    <Reveal className="productCard" key={item.content} delay={i * 70}>
                      <div className="productCard__media">
                        <img src={item.icon} alt={item.content} loading="lazy" />
                      </div>
                      <p className="productCard__title">{item.content}</p>
                    </Reveal>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

    </>
  )
}

export default Industry